import getDefaultSpreadTemplateToAdd from 'editor/src/store/design/operation/getDefaultSpreadTemplateToAdd';
import { RootState } from 'editor/src/store/index';

const isAutofillAllowed = (state: RootState) =>
  state.hostSettings.allowAutofill || !!getDefaultSpreadTemplateToAdd(state);

export default isAutofillAllowed;
